// DS2.7
import React from 'react';
import classnames from 'classnames';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import type { BiEvent } from '@wix/da-bi/pkg/events';
import PlusIcon from '../Icons/AddPlus';
import { Props as IconProps, IconSize } from '../Icons/IconWrap';
import s from './AddItem.scss';

export interface Props {
  className?: string;
  title?: string;
  titleClassName?: string;
  subtitle?: string;
  disabled?: boolean;
  onClick?: () => void;
  biData?: BiEvent;
  innerRef?: (node: HTMLElement | null) => void;
  icon?: React.ComponentType<IconProps>;
  iconSize?: IconSize;
  withCardWrapper?: boolean; // false - DS2.7.2
  error?: boolean;
  style?: Pick<React.CSSProperties, 'width' | 'height'>;
}

const AddItem: React.FC<Props> = ({
  className,
  onClick,
  title,
  titleClassName,
  disabled,
  subtitle,
  biData,
  innerRef,
  icon: Icon = PlusIcon,
  iconSize = IconSize.TINY,
  withCardWrapper = true,
  error,
  style,
}) => {
  return (
    <BiButton
      className={classnames(
        withCardWrapper ? 'ds-card' : s['borderless'],
        s['root'],
        className,
        disabled && s['disabled'],
        error && s['error']
      )}
      onClick={onClick}
      biData={biData}
      innerRef={innerRef}
      style={style}
    >
      <Icon className={s['plus']} size={iconSize} />
      {title && (
        <div className={classnames(s['title'], titleClassName)}>{title}</div>
      )}
      {subtitle && <div className={s['subtitle']}>{subtitle}</div>}
    </BiButton>
  );
};
AddItem.displayName = 'AddItem';

export default AddItem;
